import * as Preact from "preact"
import {nanoid} from "nanoid"

import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Timings from "@fae/source/engine/animating/utility/Timings.js"
import * as Motions from "@fae/source/engine/animating/utility/Motions.js"

import "./ContinuePrompt.less"

export default function(stage) {
    // if(stage.flags["tutorial:hasRallied"] != true) {
    //     return (
    //         <div class="TutorialPrompt" position="topright">
    //             <div class="Text">
    //                 The firekeeper has the power to RALLY her friends,
    //                 allowing them to act twice in a turn.
    //             </div>
    //         </div>
    //     )
    // }

    return [
        Prompt(stage),
        Status(stage),
    ]
}

function Status(stage) {
    return (
        <div class="EmberStatus">
            <span>{getStoredFoodCount(stage) + getFreshFoodCount(stage)} food</span>
            <span> / </span>
            <span number={stage?.player?.inventory?.kindling}>
                {stage?.player?.inventory?.kindling} kindling
            </span>
            <span> / </span>
            <span>3 memoria</span>
        </div>
    )
}

function getStoredFoodCount(stage) {
    let foodCount = 0
    if(stage?.player?.inventory?.items != undefined) {
        Object.values(stage.player.inventory.items).forEach((item) => {
            if(item.type == "food") {
                foodCount += 1
            }
        })
    }
    return foodCount
}

function getFreshFoodCount(stage) {
    let foodCount = 0
    Object.values(stage.units).forEach((unit) => {
        if(unit?.inventory?.items != undefined) {
            Object.values(unit?.inventory?.items).forEach((item) => {
                if(item.type == "food") {
                    foodCount += 1
                }
            })
        }
    })
    // if(foodCount > 0) {
    //     foodCount = "+" + foodCount
    // }
    // if(foodCount == 0) {
    //     foodCount = ""
    // }
    return foodCount
}

function Prompt(stage) {
    if(stage?.flags["hud"] == "hidden") {
        return (
            <div class="TutorialPrompt" isHidden={true}/>
        )
    }
    const flames = Object.values(stage.units).filter((unit) => {
        return unit.role == "flame"
            && unit.isDead != true
            && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
    })
    const torches = Object.values(stage.units).filter((unit) => {
        return unit.role == "torch"
            && unit.isDead != true
            && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
    })
    const actedPlayerUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == stage.player.affiliation
            && (unit.energy["act"] != true || unit.energy["move"] != true)
    })
    const activePlayerUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == stage.player.affiliation
            && unit.isDead != true
            && unit.deathTimer > 0 != true
            && unit.isRemoved != true
            && (unit.energy["act"] == true && unit.energy["move"] == true)
    })
    const aliveEnemyUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation == "bad"
            && unit.type != "thing"
            && unit.isDead != true
            && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
    })
    if(flames.length >= torches.length
    && aliveEnemyUnits.length == 0) {
        // if(actedPlayerUnits.length > 0) {
        //     return (
        //         <div class="TutorialPrompt" position="topright" size="small">
        //             The torch is lit!! But you can only flee at the start of your turn.
        //         </div>
        //     )
        // }
        function endEncounter() {
            const chapter = App.game.chapter
            const randomSeed = nanoid()
            // chapter.runningDeltastageSubsum = {}
            // chapter.endPlayerTurn(chapter.stage, {"seed": randomSeed})

            stage = chapter.stage

            // 1. find all ally units who are alive and haven't taken their action. mark them as not here.
            // 2. if all allies are either dead or not here, then move on to next encounter, as currently scripted.
            // 3. make sure the move encounter script also marks them as here, not not here.

            let playerUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == stage.player.affiliation
                    && unit.isRemoved != true
                    && unit.isDead != true
                    && unit.deathTimer > 0 != true
            })
            const firstevents = []
            const ESCAPE_DIRECTION = {"x": 8, "y": 0, "z": 0}
            playerUnits.forEach((unit) => {
                // if(unit.energy["invoke skill"] == true && unit.energy["move"] == true
                if(true) { // debug
                    firstevents.push({
                        "name": "MoveUnit",
                        "type": "invoke skill",
                        "deltastages": [
                            {
                                "mark": 0,
                                "unit": {
                                    "key": unit.key,
                                    "position": {
                                        "x": unit.position.x,
                                        "y": unit.position.y,
                                        "z": unit.position.z,
                                    }
                                }
                            },
                            {
                                "mark": 300,
                                "timing": Timings.easeOutQuad,
                                "motion": Motions.arc(0.5),
                                "unit": {
                                    "key": unit.key,
                                    "position": {
                                        "x": unit.position.x + ESCAPE_DIRECTION.x,
                                        "y": unit.position.y + ESCAPE_DIRECTION.y,
                                        "z": unit.position.z + ESCAPE_DIRECTION.z,
                                    },
                                }
                            },
                            {
                                "mark": 0,
                                "audio": {
                                    "triggerKey": "Unit:Move"
                                },
                            },
                            // unit.name?.toUpperCase() + " HAS PUSHED ONWARDS",
                        ]
                    })
                    firstevents.push(Step.deltastage({
                        "unit": {
                            "key": unit.key,
                            "isRemoved": true,
                        }
                    }))
                }
            })
            let steps = Stage.processEventSteps(stage, firstevents) || []
            if(steps.length > 0) stage = steps[steps.length - 1].omegastage

            // CHECK TO SEE IF WE ARE DONE HERE
            playerUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == stage.player.affiliation
                    && unit.isRemoved != true
                    && unit.isDead != true
                    && unit.deathTimer > 0 != true
            })
            if(playerUnits.length == 0) {
                const condition = stage.scripts.find((condition) => {
                    return condition.encounterKey == stage.currentEncounterKey
                        && condition.isWinCondition == true
                        && condition.trigger == "manual script"
                })
                if(condition == undefined
                || condition.events == undefined) {
                    return console.warn("Uh, whoops, couldn't find the script for " + stage.currentEncounterKey + ", to move us down the path. That's embarassing.")
                }
                steps = steps.concat(Stage.processEventSteps(stage, condition.events))
            }

            chapter.animationSequence = {"steps": steps} // is this really necessary??
            App.sequence = {"steps": steps}
            if(steps.length > 0) stage = steps[steps.length - 1].omegastage
            Stage.calculateActions(stage)
            chapter.stage = stage

            chapter.sumSteps(steps)
            chapter.actionTrace.push({
                "type": "endEncounter",
                "seed": randomSeed,
                "deltastageSum": chapter.runningDeltastageSubsum
            })
        }
        return (
            <div class="ContinueButton" onClick={endEncounter} isUsable={true}>
                <div class="Text">Onwards!!</div>
            </div>
        )
    }
    // if(flames.length >= torches.length
    // && aliveEnemyUnits.length > 0) {
    //     return (
    //         <div class="TutorialPrompt" position="topright" size="small">
    //             The torch is lit!! Now clear out these monsters.
    //         </div>
    //     )
    // }
    // return (
    //     <div class="TutorialPrompt" position="topright" size="small">
    //         Light a torch to light your way
    //     </div>
    // )
}
